import { Frequency, Product, ProductPricing, ProductPricingRules, ProductPricingType } from '@galaxy/billing';
import { BilledProduct, BillingModel, MarketplaceBillingFrequency, PricingTier } from '@vendasta/shared';

const pricingTypeToBillingModelMap = {};
pricingTypeToBillingModelMap[ProductPricingType.Standard] = BillingModel.Standard;
pricingTypeToBillingModelMap[ProductPricingType.Stairstep] = BillingModel.Stairstep;
pricingTypeToBillingModelMap[ProductPricingType.Tiered] = BillingModel.Tiered;

const frequencyMap = {};
frequencyMap[Frequency.OneTime] = MarketplaceBillingFrequency.OneTime;
frequencyMap[Frequency.Monthly] = MarketplaceBillingFrequency.Monthly;
frequencyMap[Frequency.Yearly] = MarketplaceBillingFrequency.Yearly;

export function pricingOnlyBilledProduct(sku: string, pricing: ProductPricing): BilledProduct {
  return mergePricing(null, pricing);
}

function emptyBilledProduct(): BilledProduct {
  return {
    productId: undefined,
    productName: undefined,
    billingModel: undefined,
    price: undefined,
    notes: undefined,
    iconURL: undefined,
    currency: undefined,
    billingFrequency: undefined,
    pricingTiers: undefined,
    productCategory: undefined,
    commitment: undefined,
    setupFee: undefined,
  };
}

export function mergePricing(product: Product, pricing: ProductPricing): BilledProduct {
  const billedProduct = emptyBilledProduct();
  if (product) {
    billedProduct.productName = product.name;
    billedProduct.productId = product.sku;
    billedProduct.iconURL = product.iconUrl;
  }
  if (pricing) {
    billedProduct.billingModel = pricingTypeToBillingModelMap[pricing.pricingType];
    billedProduct.currency = pricing.currency;
    billedProduct.billingFrequency = frequencyMap[pricing.frequency];
    billedProduct.pricingTiers = pricingRulesToTiers(pricing.pricingRules, pricing.isStartingPrice);
    billedProduct.commitment = pricing.commitment;
    billedProduct.setupFee = pricing.setupFee;
  }
  return billedProduct;
}

function pricingRulesToTiers(rules: ProductPricingRules[], isStartingPrice: boolean): PricingTier[] {
  return rules.map((r) => {
    return {
      rangeMin: r.minUnits || 0,
      rangeMax: r.maxUnits,
      price: r.price || 0,
      isStartingPrice: isStartingPrice,
    };
  });
}
